// src/features/location/locationSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    state: "",
    district: "",
    tehsil: "",
    village: "",
};

const LEVELS = ["state", "district", "tehsil", "village"];

const locationSlice = createSlice({
    name: "location",
    initialState,
    reducers: {
        setStateName(state, action) {
            state.state = action.payload;
            state.district = "";
            state.tehsil = "";
            state.village = "";
        },
        setDistrictName(state, action) {
            if (state.district !== action.payload) {
                state.district = action.payload;
                state.tehsil = "";
                state.village = "";
            }
        },
        setTehsilName(state, action) {
            if (state.tehsil !== action.payload) {
                state.tehsil = action.payload;
                state.village = "";
            }
        },
        setVillageName(state, action) {
            state.village = action.payload;
        },
        /**
         * clearBelow("district") clears tehsil + village
         * clearBelow("tehsil")   clears village
         */
        clearBelow(state, action) {
            const level = action.payload;
            const idx = LEVELS.indexOf(level);
            if (idx === -1) return;
            for (let i = idx + 1; i < LEVELS.length; i++) {
                state[LEVELS[i]] = "";
            }
        },
    },
});

export const {
    setStateName,
    setDistrictName,
    setTehsilName,
    setVillageName,
    clearBelow,
} = locationSlice.actions;

export default locationSlice.reducer;
